import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MainSideMenuComponent} from '@components/main-side-menu/main-side-menu.component';
import {MainBreadcrumbComponent} from '@components/main-breadcrumb/main-breadcrumb.component';
import {MainHeaderComponent} from '@components/main-header/main-header.component';
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {Dialog} from "primeng/dialog";
import {NgIf} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'main-layout',
    standalone: true,
    imports: [RouterOutlet, MainSideMenuComponent, MainBreadcrumbComponent, MainHeaderComponent, Dialog, NgIf, TranslatePipe],
    templateUrl: './main-layout.html',
    styleUrl: './main-layout.scss',
})
export class MainLayout implements OnInit {
    isCollapsed: boolean = false;
    isMobile: boolean = false;
    isSidebarOpen: boolean = false;

    constructor(private breakpointObserver: BreakpointObserver) {
    }

    ngOnInit(): void {
        this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet]).subscribe(result => {
            this.isMobile = result.matches;
            if (this.isMobile) {
                this.isCollapsed = false; 
            }
        });
    }

    toggleSidebar(): void {
        this.isSidebarOpen = !this.isSidebarOpen;
    }

    closeSidebar(): void {
        this.isSidebarOpen = false;
    }
}
